import { I18n } from 'common/i18n';
import formatString from 'common/js_utils/formatString';

interface VifValidationError extends Error {
  vifValidatorErrors?: string[];
}

const scope = 'shared.visualizations.charts';
/**
 * Creates a standardized error for when a visualization exceeds the maximum row count
 * @param {number} maxRowCount - The maximum number of rows allowed
 * @returns {Error} The error object with name and message
 */
export function createMaxRowCountError(maxRowCount: number): Error {
  const error = new Error();
  const message = formatString(I18n.t('timeline_chart.error_exceeded_max_row_count', { scope }), maxRowCount);
  error.message = message;
  error.name = 'exceededMaxRowCount';

  return error;
}

/**
 * Creates a standardized error for when a visualization has duplicate dimension values
 * @returns {Error} The error object with validation errors
 */
export function createDuplicateValuesError(): VifValidationError {
  const error = new Error() as VifValidationError;
  error.vifValidatorErrors = [I18n.t('common.error_duplicated_dimension_value', { scope })];
  return error;
}
